import React, { useState, useEffect } from "react";
import { CARD_HEIGHT, CARD_WIDTH } from "../../../config/layoutConfig";

function StoreMainImage({ store }) {
  const [imgSrc, setImgSrc] = useState("");
  const [imgObjectFit, setImgObjectFit] = useState("");

  const replaceImgWithError = (e) => {
    setImgSrc(
      "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/12/ahp_logo_pos_800x200px.jpg"
    );
    setImgObjectFit("contain");
  };

  useEffect(() => {
    // change the state when store prop changes
    setImgSrc(store.main_image);
    setImgObjectFit("cover");
  }, [store]);

  return (
    <img
      className="ahp-store-card-image"
      alt="store"
      // if the src is null, there will be no onError event, in that situation, make it an empty string
      src={imgSrc || ""}
      style={{
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        objectFit: imgObjectFit,
      }}
      onError={replaceImgWithError}
    />
  );
}

export default StoreMainImage;
